import { create } from 'zustand';
import type { ScoredGeography } from '@/types/insights';

export type LoadStatus = 'idle' | 'loading' | 'ready' | 'error';

interface DataState {
  status: LoadStatus;
  geographies: ScoredGeography[];
  warnings: string[];
  isSampleData: boolean;
  lastRefreshedAt: string | null;
  error: string | null;

  setLoading: () => void;
  setLoaded: (payload: { geographies: ScoredGeography[]; warnings: string[]; isSampleData: boolean }) => void;
  setError: (message: string) => void;
}

export const useDataStore = create<DataState>((set) => ({
  status: 'idle',
  geographies: [],
  warnings: [],
  isSampleData: false,
  lastRefreshedAt: null,
  error: null,

  setLoading: () => set({ status: 'loading', error: null }),
  setLoaded: ({ geographies, warnings, isSampleData }) =>
    set({
      status: 'ready',
      geographies,
      warnings,
      isSampleData,
      lastRefreshedAt: new Date().toISOString(),
      error: null,
    }),
  setError: (message) => set({ status: 'error', error: message }),
}));
